<template>
    <div class="bubuia-wrapper">
        <div class="content__logo">
            <a href="https://guillaumevieira.com/art/project/bubuia-70" target="_blank"
                title="Bubuia - Guillaume Vieira" class="content__logo__link">
                <img class="content__logo_bubuia" src="@/assets/logo_bubuia.svg" />
            </a>
        </div>
        <!-- <img class="content__logo_bubuia" src="@/assets/logo_bubuia.svg" /> -->
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'BubuiaWrapper',
}
</script>

<style lang="scss" scoped>
.bubuia-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content {
    &__logo_bubuia {
        width: 200px;
        height: auto;
        margin-top: 30px;
        margin-bottom: 40px;
    }

    &__logo {
        margin-top: $content-padding;
        margin-bottom: 0px;

        &__link {
            &__img {
                width: 50px;
                height: 50px;
            }
        }
    }
}
</style>
